export const clasStyles = {
  fontSize: [
    { class: "font-size1", style: { fontSize: "12px" } },
    { class: "font-size2", style: { fontSize: "14px" } },
    { class: "font-size3", style: { fontSize: "16px" } },
    { class: "font-size4", style: { fontSize: "18px" } },
    { class: "font-size5", style: { fontSize: "20px" } },
    { class: "font-size6", style: { fontSize: "22px" } },
    { class: "font-size7", style: { fontSize: "24px" } }
  ],
  fontWeight: [
    { class: "font-weight1", text: "Light", style: { fontWeight: "100" } },
    { class: "font-weight2", text: "Regular", style: { fontWeight: "200" } },
    { class: "font-weight3", text: "Semi medium", style: { fontWeight: "300" } },
    { class: "font-weight4", text: "Medium", style: { fontWeight: "400" } },
    { class: "font-weight5", text: "Semi Bold", style: { fontWeight: "500" } },
    { class: "font-weight6", text: "Bold", style: { fontWeight: "600" } },
    { class: "font-weight7", text: "Extra Bold", style: { fontWeight: "700" } }
  ],
  fontFamily: [
    {
      class: "font-family1",
      text: "Playfair",
      style: { fontFamily: '"Playfair Display", serif' }
    },
    {
      class: "font-family2",
      text: "Manrope",
      style: { fontFamily: '"Manrope", sans-serif' }
    },
    {
      class: "font-family3",
      text: "Montserrat",
      style: { fontFamily: '"Montserrat", sans-serif' }
    }
  ],

  fontDecoration: [
    { class: "font-decoration1", text: "format_bold", style: { fontWeight: "bold" } },
    { class: "font-decoration2", text: "format_italic", style: { fontWeight: 100 } },
    { class: "font-decoration3", text: "format_underlined", style: { fontWeight: 100 } },
    { class: "font-decoration4", text: "format_strikethrough", style: { fontWeight: 100 } },
    { class: "font-decoration6", text: "format_underlined_squiggle", style: { fontWeight: 100 } }
  ],
  // border: [
  //   {
  //     class: "border-class1",
  //     style: { border: "0px solid darkgray", borderRadius: "0px", backgroundColor: "#F1F3F4" }
  //   },
  //   {
  //     class: "border-class2",
  //     style: { border: "1px solid darkgray", borderRadius: "0px", backgroundColor: "#F1F3F4" }
  //   },
  //   {
  //     class: "border-class3",
  //     style: { border: "1px solid darkgray", borderRadius: "4px", backgroundColor: "#F1F3F4" }
  //   },
  //   // { class: "border-class4", style: { border: "1px solid darkgray", borderRadius: "8px" ,backgroundColor:"#F1F3F4"} },
  //   {
  //     class: "border-class5",
  //     style: { border: "2px solid darkgray", borderRadius: "0px", backgroundColor: "#F1F3F4" }
  //   },
  //   {
  //     class: "border-class6",
  //     style: { border: "2px solid darkgray", borderRadius: "4px", backgroundColor: "#F1F3F4" }
  //   },
  //   // { class: "border-class7", style: { border: "2px solid darkgray", borderRadius: "8px" ,backgroundColor:"#F1F3F4"} },
  //   {
  //     class: "border-class8",
  //     style: { border: "1px dashed darkgray", borderRadius: "0px", backgroundColor: "#F1F3F4" }
  //   },
  //   {
  //     class: "border-class9",
  //     style: { border: "1px dashed darkgray", borderRadius: "4px", backgroundColor: "#F1F3F4" }
  //   },
  //   // { class: "border-class10", style: { border: "1px dashed darkgray", borderRadius: "8px" ,backgroundColor:"#F1F3F4"} },
  //   {
  //     class: "border-class11",
  //     style: { borderBottom: "2px solid darkgray", borderRadius: "4px", backgroundColor: "#F1F3F4" }
  //   }
  // ],
  border: [
    {
      class: "new-border-class1",
      style: { border: "0px solid darkgray", backgroundColor: "#F1F3F4" }
    },
    {
      class: "new-border-class2",
      style: { border: "1px solid darkgray", backgroundColor: "#F1F3F4" }
    },
    {
      class: "new-border-class3",
      style: { border: "2px solid darkgray", backgroundColor: "#F1F3F4" }
    },
    {
      class: "new-border-class4",
      style: { border: "1px dashed darkgray", backgroundColor: "#F1F3F4" }
    },
    {
      class: "new-border-class5",
      style: { border: "1px dotted darkgray", backgroundColor: "#F1F3F4" }
    },
    {
      class: "new-border-class6",
      style: { borderBottom: "1px solid darkgray", backgroundColor: "#F1F3F4" }
    }
  ],
  borderRadius: [
    {
      class: "radius-class1",
      style: { border: "1px solid darkgray", backgroundColor: "#F1F3F4", borderRadius: "0px" }
    },
    {
      class: "radius-class2",
      style: { border: "1px solid darkgray", backgroundColor: "#F1F3F4", borderRadius: "4px" }
    },
    {
      class: "radius-class3",
      style: { border: "1px solid darkgray", backgroundColor: "#F1F3F4", borderRadius: "8px" }
    },
    {
      class: "radius-class4",
      style: { border: "1px solid darkgray", backgroundColor: "#F1F3F4", borderRadius: "20px" }
    }
  ],
  shadow: [
    { class: "shadow-class1", style: { boxShadow: "0px 8px 16px 0px #eae9e9", backgroundColor: "#F1F3F4" } },
    {
      class: "shadow-class2",
      style: { boxShadow: "0px 8px 16px 0px rgba(168, 166, 166, 0.5)", backgroundColor: "#F1F3F4" }
    },
    { class: "shadow-class3", style: { boxShadow: "0px 8px 16px 0px #667085", backgroundColor: "#F1F3F4" } }
  ],
  imageShape: [
    {
      class: "image-class1",
      text: "Full width and height",
      style: {
        borderRadius: "10px",
        border: "2px solid darkgray",
        padding: "4px",
        height: "20px",
        width: "40px",
        backgroundColor: "rgb(241, 243, 244)"
      }
    },
    {
      class: "image-class2",
      text: "Auto height with max width",
      style: {
        border: "2px solid darkgray",
        borderRadius: "4px",
        padding: "4px",
        height: "20px",
        width: "40px",
        backgroundColor: "rgb(241, 243, 244)"
      }
    },
    {
      class: "image-class3",
      text: "Circular with full dimensions",
      style: {
        borderRadius: "100%",
        border: "2px solid darkgray",
        padding: "4px",
        height: "20px",
        width: "40px",
        backgroundColor: "rgb(241, 243, 244)"
      }
    },
    {
      class: "image-class4",
      text: "Circular with fixed size",
      style: {
        borderRadius: "50%",
        border: "2px solid darkgray",
        padding: "4px",
        height: "20px",
        width: "20px",
        backgroundColor: "rgb(241, 243, 244)"
      }
    },
    {
      class: "image-class5",
      text: "Elliptical shape",
      style: {
        border: "2px solid darkgray",
        borderRadius: "50% / 30%",
        padding: "4px",
        height: "25px",
        width: "30px",
        backgroundColor: "rgb(241, 243, 244)"
      }
    }
  ],
  imagePadding: ["image-p-1", "image-p-2", "image-p-3"],
  imageShadow: ["image-shadow-1", "image-shadow-2", "image-shadow-3"],
  imageBorder: ["image-border-1", "image-border-2", "image-border-3"],

  alignment: [
    {
      class: "align-class2",
      text: "align_horizontal_left",
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        marginRight: "auto",
        textAlign: "start"
      }
    },
    {
      class: "align-class1",
      text: "align_center",
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginRight: "auto",
        textAlign: "center"
      }
    },

    {
      class: "align-class3",
      text: "align_horizontal_right",
      style: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        marginLeft: "auto",
        textAlign: "end"
      }
    }
  ],
  padding: [
    { class: "padding-zero", style: { padding: "0px" }, name: "no padding" },
    { class: "padding-class1", style: { padding: "8px" }, name: "padding small" },
    { class: "padding-class2", style: { padding: "12px" }, name: "padding med" },
    { class: "padding-class3", style: { padding: "16px" }, name: "padding large" },
    { class: "padding-class4", style: { padding: "20px" }, name: "padding xl" }
  ],
  margin: [
    { class: "margin-zero", style: { margin: "0px" }, name: "no margin" },
    // { class: "margin-class1", style: { margin: "4px" } },
    { class: "margin-class2", style: { margin: "8px" }, name: "margin small" },
    { class: "margin-class3", style: { margin: "12px" }, name: "margin med" },
    // { class: "margin-class4", style: { margin: "20px" } },
    { class: "margin-right-1", style: { marginRight: "8px" }, name: "left margin small" },
    { class: "margin-right-2", style: { marginRight: "12px" }, name: "left margin med" },
    // { class: "margin-right-3", style: { marginRight: "20px" } },
    { class: "margin-left-1", style: { marginLeft: "8px" }, name: "right margin small" },
    { class: "margin-left-2", style: { marginLeft: "12px" }, name: "right margin med" }
    // { class: "margin-left-3", style: { marginLeft: "20px" } }
  ],

  type: [
    { class: "builder_btn_primary", style: { background: "var(--primary-color)", color: "#fff" }, name: "Primary" },
    {
      class: "builder_btn_secondary",
      style: { background: "#fff", color: "var(--primary-color)", border: "1px solid var(--primary-color)" },
      name: "Secondary"
    },
    {
      class: "builder_btn_tertiary",
      style: { background: "#fff", color: "var(--builder-font-color)", border: "unset" },
      name: "Tertiary"
    },
    { class: "icon_label", style: { background: "#fff", color: "black", border: "1px solid #10182b" }, name: "Icon" },
    {
      class: "builder_btn_success",
      style: { background: "#34a853", color: "#fff", border: "1px solid #34a853" },
      name: "Success"
    },
    {
      class: "builder_btn_delete",
      style: { background: "#d92d20", color: "#fff", border: "1px solid #d92d20" },
      name: "Delete"
    }
  ],
  size: [
    {
      class: "button-size3",
      style: { height: "24px", alignItems: "center" },
      name: "Small"
    },
    {
      class: "button-size1",
      style: { height: "32px", alignItems: "center" },
      name: "Medium"
    },
    {
      class: "button-size2",
      style: { height: "42px", alignItems: "center" },
      name: "Large"
    }
  ]

  // iconPosition: ["icon-top", "icon-right"]
};

export const convertMapToClassname = (obj) => {
  const modifiedClassName = Object.values(obj).join(" ");
  return modifiedClassName;
};
